// Prism - is a lightweight, extensible syntax highlighter, built with modern web standards in mind: https://prismjs.com/

window.Prism = require("prismjs/prism.js");
require("prismjs/components/prism-markup.js");
require("prismjs/components/prism-markup-templating.js");
require("prismjs/components/prism-bash.js");
require("prismjs/components/prism-javascript.js");
require("prismjs/components/prism-scss.js");
require("prismjs/components/prism-css.js");
require("prismjs/components/prism-php.js");
require("prismjs/components/prism-php-extras.js");
require("prismjs/plugins/normalize-whitespace/prism-normalize-whitespace.js");
require("@/src/js/vendors/plugins/prism.init.js");

require('./prismjs.scss');
